function calcGraphSliderRange(graphStart, graphLength, areaStart, areaWidth, signalLength) {
    const areaEnd = areaStart + areaWidth;

    // Часть, куда ползунок двигать ВПРАВО (смещает представительный комплекс в НАЧАЛО графика) это минимум:
    // * расстояния от начала графика до начала _QRS_
    // * длины фрагмента сигнала за пределами графика справа
    const sliderRange_right = Math.min(areaStart, Math.max(0, signalLength - (graphStart + graphLength)));

    // Часть, куда ползунок двигать ВЛЕВО (смещает представительный комплекс в КОНЕЦ графика) это минимум:
    // * расстояния от начала графика до начала сигнала (начало сигнала всегда 0)
    // * расстояния от конца _QRS_ до конца графика
    const sliderRange_left = Math.min(graphStart, graphLength - areaEnd);
    const sliderRange = sliderRange_left + sliderRange_right;
    const sliderValue = sliderRange - sliderRange_right;

    const sliderParams = {
        sliderValue,
        sliderRange
    };
    return sliderParams;
}

export default calcGraphSliderRange;
